import BoardingProgress from '../../BoardingProgress.js';
import { useTranslation } from 'react-i18next';
import UploadPage from './UploadPage.js';
import { Button, Divider, Label } from '@fluentui/react-components';
import { DocumentCheckmarkRegular, DismissRegular } from '@fluentui/react-icons';
import {
    MessageBar,
    MessageBarTitle,
    MessageBarBody,
    MessageBarActions,
} from '@fluentui/react-components';
import { useState } from 'react';
const Upload = ({  setCurrentStep, }) => {
    const currentProgressStep = 1
    const { t } = useTranslation();

    const [showUpWarningMessageBar, setShowUpWarningMessageBar] = useState(false)
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    minheight: '1100px',
                    flexDirection: 'column',
                    alignContent: 'center',
                    background: '#FAF9F8'
                }}
            > {showUpWarningMessageBar &&
                <div style={{ width: "100%", color: "black" }}>
                   <MessageBar intent="warning"  >
                     <MessageBarBody>
                       <MessageBarTitle>{t("boarding.pleaseConfirmPolicy")}</MessageBarTitle>
                     </MessageBarBody>
                   <MessageBarActions containerAction={
                   <Button appearance="transparent" icon={<DismissRegular />} 
                        onClick={() => setShowUpWarningMessageBar(false)} />}>
                        </MessageBarActions>
                    </MessageBar>
                </div>}
                <div style={{
                    width: '1400px',
                    margin: '0 auto',
                    minHeight: '1200px',
                }}>
                    {/* Step Navigation */}
                    <BoardingProgress currentProgressStep={currentProgressStep} />
                    <div style={{
                        marginTop: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        justifyContent: 'center'
                    }}>
                        <Divider style={{ width: '1200px', marginTop: '40px' }} />
                    </div>
                    <div style={{ color: 'black', marginTop: '20px', width: '100%', display: 'flex', justifyContent: 'center', }}>
                        <div><DocumentCheckmarkRegular style={{ fontSize: '20px' }} /></div>
                        <div><Label size='large' style={{ fontSize: '20px', }}>{t('boarding.setupLogoAndSignatureForDisplayOnTemplate')}</Label></div>
                    </div>
                    <UploadPage setCurrentStep={setCurrentStep} showUpWarningMessageBar={showUpWarningMessageBar} setShowUpWarningMessageBar={setShowUpWarningMessageBar} />
                </div>
            </div>
        </>
    );
};

export default Upload;
